(function($, Drupal) {
  function resizeSlid($slid) {
    const height = $(".carousel-caption", $slid).outerHeight();
    $slid.closest(".carousel-item").height(height);
  }

  Drupal.behaviors.bokaCarouselAutoHeight = {
    attach(context) {
      once(
        "bokaCarouselAutoHeight",
        ".carousel.--carousel-auto-height",
        context
      ).forEach(carousel => {
        const $carousel = $(carousel);
        $(".carousel-item > .field__item", $carousel).click(function() {
          resizeSlid($(this));
        });

        $(".carousel-item > .field__item", $carousel).each(function() {
          resizeSlid($(this));
        });

        $carousel.on("slid.bs.carousel", function(event) {
          const $slid = $(event.relatedTarget);
          resizeSlid($slid);
        });
      });
    }
  };

  Drupal.behaviors.bokaSliderForCards = {
    attach(context) {
      once(
        "bokaSliderForCards",
        ".paragraph--type--slider-for-cards .slider-inner",
        context
      ).forEach(sliderInner => {
        const $sliderInner = $(sliderInner);
        const $slider = $sliderInner.closest(".slider");
        const seconds = $(".slider-item", $sliderInner).length * 1.5 + 1;
        let maxHeight = $slider.outerHeight();
        $(".slid", $sliderInner).each(function() {
          if (maxHeight < $(this).outerHeight()) {
            maxHeight = $(this).outerHeight();
          }
          $(this).addClass("h100");
        });
        $slider.css("height", maxHeight);

        let left = $slider.outerWidth();
        $(".slider-item", $sliderInner).each(function() {
          left -= $(this).outerWidth();
        });

        $sliderInner.css("transition", `all ${seconds}s linear`);

        $slider.on("mouseover", function() {
          $sliderInner.css("left", `${left}px`);
        });
        $slider.on("mouseout", function() {
          $sliderInner.css("left", 0);
        });
      });
    }
  };
})(jQuery, Drupal);
